
export default {
  orsLPolyline: {
    type: 'Type',
    surface: 'Oberfläche',
    unknownSurfaceType: 'Unbekannt'
  }
}
